import React, { Component, PropTypes, cloneElement } from 'react';
import { connect } from 'react-redux';
import {
  resetPassword,
  passwordInputModified,
  passwordResetError,
  toggleConnectionNotifications,
  hydrateFromServer,
  addTempUser,
  deleteTempUser,
  tempUserPropModified,
  addNewUsers,
  clearAddUserMessage,
  clearEditUserMessage,
  approveOrRejectUser,
  disableUser,
  updateUserBeingEdited,
  editUserPropModified,
  confirmedDisassociateSecondaryEmail,
  resendSecondaryEmailConfirmationLink,
  addSecondaryEmail,
  resendConfirmationLink,
  clearManageUsersMessage,
  saveUserBeingEdited } from '../../stores/settings/settings-actions';
import LeftNav from './settings-left-nav.jsx';
import { push } from 'react-router-redux';
import R from 'ramda';
import Settings from './settings';
import BillingSettings from './billing/index';
import { getUsersByFilter } from '../../stores/settings/userManagement/actions';
import { triggerNoAccessWarning, getFeatureAccess } from '../../middleware/accessCheckHelperFns';

class SettingsContainer extends Component {

  componentWillMount() {
    const { dispatch, history, params } = this.props;

    dispatch(getUsersByFilter('team'));

    if (this.props.settings.get('isHydratedFromServer') === false) {
      return dispatch(hydrateFromServer())
      .catch((err) => {
        console.log(err);
      });
    }
  }

  resetPassword = () => {
    const { dispatch } = this.props;
    const { oldPassword, newPassword, confNewPassword } = this.props.settings.toJS();

    // client-side validation
    let errorMessage;
    let errorFields;

    if (oldPassword === '' || newPassword === '' || confNewPassword === '') {
      errorMessage = 'Fields cannot be blank';
      errorFields = ['oldPasswordError', 'newPasswordError'];
    } else if (newPassword !== confNewPassword) {
      errorMessage = 'New passwords must match';
      errorFields = ['newPasswordError'];
    }

    // more client side validation goes here

    if (errorMessage) return dispatch(passwordResetError(errorMessage, errorFields));

    return dispatch(resetPassword(oldPassword, newPassword))
    .catch((err) => {
      console.log(err);
    });
  };

  toggleConnectionNotifications = () => {
    const { dispatch, settings } = this.props;
    const newNotifValue = !settings.get('connectionNotificationsEnabled');
    return dispatch(toggleConnectionNotifications(newNotifValue))
    .catch((err) => {
      console.log(err);
    });
  };

  onChangeRoute = (route) => {
    if (route === 'company-settings') {
      const adminAccess = getFeatureAccess({ user: this.props.user }, '', 'admin');
      if (R.either(R.isNil, R.isEmpty)(adminAccess)) return this.props.dispatch(triggerNoAccessWarning({ featureName: 'admin', access: 'read' }));
    }
    return this.props.push(`/settings/${route}`);
  }
  render() {
    const { dispatch, user, settings } = this.props;
    const props = {
      resetPassword: this.resetPassword,
      passwordInputModified: (passType, event) => dispatch(passwordInputModified(passType, event.target.value)),
      toggleConnectionNotifications: this.toggleConnectionNotifications,
      addTempUser: () => dispatch(addTempUser()),
      deleteTempUser: key => dispatch(deleteTempUser(key)),
      tempUserPropModified: (key, propName, newValue) => dispatch(tempUserPropModified(key, propName, newValue)),
      addNewUsers: clickedButton => dispatch(addNewUsers(clickedButton, settings.get('tempUsers'), settings.get('currentUserRole'))),
      clearAddUserMessage: () => dispatch(clearAddUserMessage()),
      clearEditUserMessage: () => dispatch(clearEditUserMessage()),
      approveOrRejectUser: (userObject, action) => dispatch(approveOrRejectUser(userObject, action)),
      disableUser: userObject => dispatch(disableUser(userObject)),
      updateUserBeingEdited: userObject => dispatch(updateUserBeingEdited(userObject)),
      editUserPropModified: (propName, newValue) => dispatch(editUserPropModified(propName, newValue)),
      saveUserBeingEdited: userObject => dispatch(saveUserBeingEdited(userObject)),
      disassociateSecondaryEmail: id => dispatch(confirmedDisassociateSecondaryEmail(id)),
      resendSecondaryEmailConfirmationLink: email => dispatch(resendSecondaryEmailConfirmationLink(email)),
      addSecondaryEmail: email => dispatch(addSecondaryEmail(email)),
      resendConfirmationLink: email => dispatch(resendConfirmationLink(email)),
      clearManageUsersMessage: () => dispatch(clearManageUsersMessage()),
      ...this.props,
    };

    if (!user.user.userID) return false;
    return (
      <div className="l-app-content l-left-nav-with-content" style={{ paddingTop: '65px' }}>
        <LeftNav className="settings-left-nav l-left-nav" {...this.props} />
        <div className="l-left-nav-content">
          <Settings activeRoute={this.props.params.activeRoute} onChangeRoute={this.onChangeRoute} {...props} />
        </div>
      </div>
    );
  }

}

SettingsContainer.propTypes = {
  dispatch: PropTypes.func,
  history: PropTypes.object,
  params: PropTypes.object,
  settings: PropTypes.object,
  user: PropTypes.object,
  children: PropTypes.any,
};

const select = (state) => ({
  settings: state.settings,
  billing: state.billing.toJS(),
});

export default connect(select, { push })(SettingsContainer);

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/settings/settingsContainer.jsx